{
  "manager": {
    "bannersCreate": {
      "textLabel": "Text",
      "typeLabel": "Type",
      "locationLabel": "Location",
      "saveBanner": "Save Banner",
      "editBanner": "Edit Banner",
      "createBanner": "Create Banner",
      "entityName": "Banner",
      "bannerCreated": "Banner created!"
    },
    "bannersIndex": {
      "title": "Banners"
    }
  }
}
